export const update_user_timeout = `mutation update_user_timeout($input: Int!){
    update_user_timeout(input: $input)
}`;
